import { inject, provideAppInitializer } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { CoreService } from "../services/core.service";

export async function runMaintenanceCheck(coreService: CoreService): Promise<void> {
  try {
    const response: any = await firstValueFrom(coreService.fetchMaintenanceStatus());
    if (response?.status === "ok") {
      const result = response?.result?.[0];
      if (result && result.ON_MAINTENANCE?.toString().trim().toLowerCase() !== "no") coreService.redirectToMaintenance();
    }
  } catch (error) {
    console.error("Error fetching maintenance mode status:", error);
    coreService.redirectToMaintenance();
  }
}

export function initializeMaintenance(): () => Promise<void> {
  const coreService = inject(CoreService);
  return () => runMaintenanceCheck(coreService);
}

export const provideMaintenance = () =>
  provideAppInitializer(() => {
    const initializerFn = initializeMaintenance();
    return initializerFn();
  });
